export const MERCY_CONTENT_MAX_WIDTH = 1020
export const MERCY_CONTENT_PADDING = 24
